/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { formatCheck2Frontend } from "../../../../actions/Checks/util";
import { Check, CHECK_LOCATION } from "../../../../actions/Layers/constants";
import useConfig, { useTenantFormOptions } from "../../../../actions/Tenants/config/configHook";
import { useLayerChecks } from "../../../../hooks/useLayerChecks";
import { callAvosApi } from "../../../../utils/useAvosApiHook";
import { MetaRow } from "./LayerMeta";

import { useRouteLayer, useRouteLayerChildren } from "../../../../hooks/useCurrentEntities";

export default function ArrivalCheck({ subconfig, title }) {
    const layer = useRouteLayer();
    const children = useRouteLayerChildren();
    const { data: checks = [] } = useLayerChecks(layer?.tenant_id, layer?.id ?? undefined);
    const arrivalCheck = checks.filter((i) => i.location === CHECK_LOCATION.ARRIVAL).sort((a, b) => b.check_id - a.check_id);
    const [check, setCheck] = useState<Check | null>(null);

    const LatestArrivalCheckkId = arrivalCheck[0];

    useEffect(() => {
        if (!LatestArrivalCheckkId) {
            return;
        }
        callAvosApi(`/checks/${LatestArrivalCheckkId.check_id}/`).then((response) => {
            setCheck(formatCheck2Frontend(response.data));
        });
    }, [LatestArrivalCheckkId]);


    const form_options = useTenantFormOptions();
    const config = useConfig();

    if (!layer || !layer.id || !subconfig) {
        return null;
    }

    return (
        <>
            <h3 className="mb-3">{title}</h3>

            {subconfig.map((i, index) => <MetaRow key={index} label={i.label} value={i.set_value({
                config,
                layer,
                check, // * To be used in check tables and layer overview
                fruit: null, // * Fruit list is not available on overview screen
                children,
                form_options // * used to translate form values to labels
            }).display_component()} />)}
        </>
    );
}

ArrivalCheck.propTypes = {
    subconfig: PropTypes.array,
    title: PropTypes.string
};
